/* Layout */
//
const Layout = () => import("@/layout")

import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']    control the page roles (you can set multiple roles)
 title: 'title'               the name show in sidebar and breadcrumb (recommend set)
 icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
 breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
 activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
 }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
// 权限：admin门店，doctor医师，pharmacist药师，user门店用户
export const constantRoutes = [// ====================  框架界面  ====================
  {
    path: "/dc/admin/login",
    component: () => import("@/views/frame/page/login/index"),
    meta: { title: "用户登录", icon: "dashboard" },
    hidden: true,
    roles: ['*']
  }, {
    path: "/dc/admin/skip",
    component: () => import("@/views/frame/page/skip"),
    meta: { title: "跳转中", icon: "dashboard" },
    hidden: true,
    roles: ['*']
  }, {
    path: "/dc/admin/skip2",
    component: () => import("@/views/frame/page/login/skip"),
    meta: { title: "跳转中", icon: "dashboard" },
    hidden: true,
    roles: ['*']
  }, {
    path: "/404",
    component: () => import("@/views/frame/page/error/404"),
    meta: { title: "404 - 页面未找到", icon: "dashboard" },
    hidden: true,
    roles: ['*']
  },

  // ====================  layout布局的界面  ====================
  {
    path: "/", component: Layout, redirect: "/base/home", children: [// ====================  默认首页  ====================
      {
        path: "/base/home", component: () => import("@/views/business/page/Home"), meta: {
          title: "主页", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist', 'user'], code: "000", // 添加菜单 code
          menuName: "首页" // 添加菜单名称
        }
      }, // ====================  基础界面 - 主页  ====================
      {
        path: "/business/home",
        component: () => import("@/views/business/page/Home"),
        meta: { title: "主页", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist', 'user'] }

      }, // ====================  门店管理 - 门店字典 - 门店诊疗字典  ====================
      {
        name: "clinic_sym_dic",
        meta: { title: "症状词典项", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_sym_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicSymDic")
      }, {
        name: "clinic_family_dic",
        meta: { title: "家族病词典项", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_family_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicFamilyDic")
      }, {
        name: "clinic_his_dic",
        meta: { title: "既往史词典项", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_his_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicHisDic")
      }, {
        name: "clinic_fdm_dic",
        meta: { title: "四诊法词典项", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_fdm_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicFdmDic")
      }, {
        name: "clinic_phy_dic",
        meta: { title: "体质词典项", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_phy_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicPhyDic")
      }, {
        name: "clinic_diag_dic",
        meta: { title: "诊断词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_diag_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicDiagDic")
      }, {
        name: "clinic_allergy_dic",
        meta: { title: "过敏史词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_allergy_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicAllergyDic")
      }, {
        name: "clinicchdiagdic",
        meta: { title: "中医病词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinicchdiagdic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicChDiagDic.vue"),
        roles: ['admin', 'doctor', 'pharmacist', 'user']
      }, {
        name: "clinicchyndromedic",
        meta: { title: "中医症词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinicchyndromedic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicChYndromeDic.vue")
      }, {
        name: "clinicchtherapydic",
        meta: { title: "治法词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinicchtherapydic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicChTherapyDic.vue")
      }, {
        name: "MedDirectory",
        meta: { title: "药品描述词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_med_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicMedDic.vue")
      }, {
        name: "clinic_chain_dic",
        meta: { title: "供应链词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_chain_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicChainDic.vue")
      }, {
        name: "clinic_classify_dic",
        meta: { title: "物料分类词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_classify_dic/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicClassifyDic")
      }, {
        name: "clinic_materiel",
        meta: { title: "物料词典", icon: "dashboard", roles: ['admin'] },
        path: "/business/page/dictionary/clinic_materiel/:viewMode/:mode",
        component: () => import("@/views/business/page/dictionary/ClinicMateriel")
      }, {
        path: "/business/clinic/store_info",
        component: () => import("@/views/business/page/clinic/StoreInfo"),
        meta: { title: "门店", icon: "dashboard", roles: ['admin'] }
      },
      {
        path: "/business/clinic/robot/:viewMode/:mode",
        component: () => import("@/views/business/page/robot/Robot.vue"),
        meta: { title: "设备管理", icon: "dashboard", roles: ['admin'] }
      },
      {
        path: "/business/clinic/store_user/:viewMode/:mode",
        name: "storeuser",
        component: () => import("@/views/business/page/clinic/StoreUser"),
        meta: { title: "门店人员", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/clinic/enroll_fee/:viewMode/:mode",
        component: () => import("@/views/business/page/clinic/EnrollFee"),
        meta: { title: "挂号费", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/clinic/serve_fee/:viewMode/:mode",
        component: () => import("@/views/business/page/clinic/ServeFee"),
        meta: { title: "服务费", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/clinic/position/:viewMode/:mode",
        component: () => import("@/views/business/page/clinic/Position"),
        meta: { title: "药库", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/manager/clinic/inventory/inventory/inventory/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/Inventory"),
        name: "inventory",
        meta: { title: "库存", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/manager/clinic/inventory/inventory/statement/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/Statement"),
        name: "statement",
        meta: { title: "库存流水", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/manager/clinic/inventory/retail/retail_ord/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/RetailOrd"),
        name: "retail_ord",
        meta: { title: "零售单", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/manager/clinic/inventory/change/in_ord/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/InOrd"),
        name: "in_ord",
        meta: { title: "入库单", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/manager/clinic/inventory/change/out_ord/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/OutOrd"),
        name: "out_ord",
        meta: { title: "出库单", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/manager/clinic/inventory/allocation/allocation_ord/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/AllocationOrd"),
        name: "allocation_ord",
        meta: { title: "调拨单", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/manager/clinic/inventory/check/check_ord/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/CheckOrd"),
        name: "check_ord",
        meta: { title: "盘点单", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/settlement/take_medicine",
        component: () => import("@/views/business/page/settlement/takeMedicine/index.vue"),
        meta: { title: "中成药发药", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/settlement/take_chmedicine",
        component: () => import("@/views/business/page/settlement/takeChmedicine/index.vue"),
        meta: { title: "饮片发药", icon: "dashboard" }
      }, {
        path: "/business/settlement/take_retail",
        component: () => import("@/views/business/page/settlement/takeMedicine/index.vue"),
        meta: { title: "零售发药", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist'] }
      }, {
        path: "/business/treatment/enroll",
        component: () => import("@/views/business/page/treatment/enroll/Enroll"),
        meta: { title: "挂号", icon: "dashboard", roles: ['admin', 'doctor', 'user'] }
      },
      {
        name: "std_prescription",
        meta: { title: "标准处方", icon: "dashboard", roles: ['admin', 'doctor'] },
        path: "/business/manager/clinic/treatment/std_prescription/std_prescription/:viewMode/:mode",
        component: () => import("@/views/business/page/treatment/StdPrescription.vue")

      },
      {
        name: "inspection_Record",
        meta: { title: "检查记录", icon: "dashboard", roles: ['admin', 'doctor'] },
        path: "/business/manager/clinic/treatment/inspection_Record/inspection_Record/:viewMode/:mode",
        component: () => import("@/views/business/page/treatment/treatment/inspectionRecord.vue")

      },
      {
        path: "/business/treatment/treatment", // component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        meta: { title: "诊疗", icon: "dashboard", roles: ['doctor', 'user'] }

      },
      {
        path: "/business/treatment/medtreatment", // component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        meta: { title: "中医病诊疗", icon: "dashboard", roles: ['doctor', 'user'] }

      },
      {
        path: "/business/treatment/demo", // component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        component: () => import("@/views/test/demo.vue"),
        meta: { title: "测试", icon: "dashboard", roles: ['doctor', 'user'] }

      },
      {
        path: "/business/treatment/xitreatment", // component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        meta: { title: "西医病诊疗", icon: "dashboard", roles: ['doctor', 'user'] }

      },
      {
        path: "/business/treatment/zhengtreatment", // component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        component: () => import("@/views/business/page/treatment/treatment/index.vue"),
        meta: { title: "中医证诊疗", icon: "dashboard", roles: ['doctor', 'user'] }

      }, // 门店 - 结算
      // {
      //   path: "/business/settlement/settlement",
      //   component: () => import("@/views/business/page/settlement/Settlement"),
      //   meta: { title: "结算", icon: "dashboard", roles: ['admin', 'doctor'] }
      // },
      {
        path: "/business/settlement/retailStlmt/:viewMode/:mode",
        component: () => import("@/views/business/page/settlement/RetailStlmt.vue"),
        meta: { title: "零售结算单", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/settlement/diagStlmt/:viewMode/:mode",
        component: () => import("@/views/business/page/settlement/DiagStlmt.vue"),
        meta: { title: "就诊结算单", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/settlement/TherapyStlmt/:viewMode/:mode",
        component: () => import("@/views/business/page/settlement/TherapyStlmt.vue"),
        meta: { title: "理疗结算单", icon: "dashboard", roles: ['admin', 'doctor'] }
      },
      {
        path: "/business/settlement/PhysicalStlmt/:viewMode/:mode",
        component: () => import("@/views/business/page/settlement/PhysicalStlmt.vue"),
        meta: { title: "体质报告结算单", icon: "dashboard", roles: ['admin', 'doctor'] }
      },
      {
        path: "/business/settlement/MonthlyStlmt/:viewMode/:mode",
        component: () => import("@/views/business/page/settlement/MonthlyStlmt.vue"),
        meta: { title: "包月结算单", icon: "dashboard", roles: ['admin', 'doctor'] }
      },
      {
        path: "/business/settlement/PhysicalBilling/:viewMode/:mode",
        component: () => import("@/views/business/page/settlement/PhysicalBilling.vue"),
        meta: { title: "体检报告月度对账单", icon: "dashboard", roles: ['admin', 'doctor'] }
      },
      {
        path: "/business/settlement/yunying",
        component: () => import("@/views/business/page/settlement/yunying.vue"),
        meta: { title: "门店运营数据", icon: "dashboard", roles: ['admin', 'doctor'] }
      },
      {
        path: "/business/settlement/constitutionStore",
        component: () => import("@/views/business/page/settlement/constitutionStore.vue"),
        meta: { title: "门店体质检测统计", icon: "dashboard", roles: ['admin'] }
      },
      {
        path: "/business/settlement/padusageStore",
        component: () => import("@/views/business/page/settlement/padUsageStore.vue"),
        meta: { title: "门店PAD使用情况统计", icon: "dashboard", roles: ['admin'] }
      },
      // 门店 - 评价
      {
        path: "/business/evaluate/TreatmentEvaluate/:viewMode/:mode",
        component: () => import("@/views/business/page/evaluate/TreatmentEvaluate.vue"),
        meta: { title: "诊疗评价", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/evaluate/TherapyEvaluate/:viewMode/:mode",
        component: () => import("@/views/business/page/evaluate/TherapyEvaluate.vue"),
        meta: { title: "理疗评价", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/evaluate/ClinicEvaluate/:viewMode/:mode",
        component: () => import("@/views/business/page/evaluate/ClinicEvaluate.vue"),
        meta: { title: "门店评估", icon: "dashboard", roles: ['admin'] }
      }, // 健康 - 用户
      {
        path: "/business/user/UserStore/:viewMode/:mode",
        component: () => import("@/views/business/page/user/UserStore.vue"),
        meta: { title: "用户就医门店", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/user/Appointment/:viewMode/:mode",
        component: () => import("@/views/business/page/user/Appointment.vue"),
        meta: { title: "预约信息", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/user/Consultation/:viewMode/:mode",
        component: () => import("@/views/business/page/user/Consultation.vue"),
        meta: { title: "医患关联", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, // 健康 - 检查
      {
        path: "/business/inspect/PhyDiagRecord/:viewMode/:mode",
        component: () => import("@/views/business/page/inspect/PhyDiagRecord.vue"),
        meta: { title: "体质诊断记录", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/inspect/InspectRecord/:viewMode/:mode",
        component: () => import("@/views/business/page/inspect/InspectRecord.vue"),
        meta: { title: "检查记录", icon: "dashboard", roles: ['admin'] }
      }, {
        path: "/business/inspect/healthPc/:viewMode/:mode",
        component: () => import("@/views/business/page/inspect/healthPc.vue"),
        meta: { title: "健康管理", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist', 'user'] }
      },
      {
        path: "/business/health/patient/:viewMode/:mode",
        component: () => import("@/views/business/page/health/Patient.vue"),
        meta: { title: "患者管理", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist', 'user'] }
      },
      // 健康 - 健康
      {
        path: "/business/health/HealthInfo/:viewMode/:mode",
        component: () => import("@/views/business/page/health/HealthInfo.vue"),
        meta: { title: "健康档案", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/health/MedBatch/:viewMode/:mode",
        component: () => import("@/views/business/page/health/MedBatch.vue"),
        meta: { title: "用药批次", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/health/MedRecord/:viewMode/:mode",
        component: () => import("@/views/business/page/health/MedRecord.vue"),
        meta: { title: "用药记录", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/health/FoodRecord/:viewMode/:mode",
        component: () => import("@/views/business/page/health/FoodRecord.vue"),
        meta: { title: "饮食记录", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/health/SleepRecord/:viewMode/:mode",
        component: () => import("@/views/business/page/health/SleepRecord.vue"),
        meta: { title: "睡眠记录", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/health/SportRecord/:viewMode/:mode",
        component: () => import("@/views/business/page/health/SportRecord.vue"),
        meta: { title: "运动记录", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/health/MassageRecord/:viewMode/:mode",
        component: () => import("@/views/business/page/health/MassageRecord.vue"),
        meta: { title: "按摩记录", icon: "dashboard", roles: ['admin', 'doctor'] }
      }, {
        path: "/business/health/tizhi/:viewMode/:mode",
        component: () => import("@/views/business/page/inventory/tizhi"),
        meta: { title: "体质商品", icon: "dashboard", roles: ['admin', 'doctor'] }
      }]
  },
  {
    path: "/business/inspect/healthPad",
    component: () => import("@/views/business/page/inspect/healthPad.vue"),
    meta: { title: "健康管理", icon: "dashboard", roles: ['admin', 'doctor', 'pharmacist', 'user'] }
  },
  {
    path: "/business/treatment/wenzhen", // component: () => import("@/views/business/page/treatment/treatment/index.vue"),
    component: () => import("@/views/business/page/treatment/wenzhen/index.vue"),
    meta: { title: "问诊", icon: "dashboard", roles: ['doctor', 'user'] }

  },
  // ====================  大屏看板界面  ====================
  {
    path: "/1",
    component: () => import("@/views/frame/page/error/404"),
    meta: { title: "404 - 页面未找到", icon: "dashboard" },
    hidden: true
  },

  // 404页，*统配，必须设置在最后
  { path: "*", redirect: "/404", hidden: true }]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }), routes: constantRoutes
})

// 过滤路由函数
export function filterRoutes(routes, userRole) {
  return routes.map(route => {
    const clonedRoute = { ...route }

    if (clonedRoute.children) {
      // 递归过滤子路由
      clonedRoute.children = filterRoutes(clonedRoute.children, userRole)

      // 如果子路由全部被过滤掉，隐藏父路由
      if (clonedRoute.children.length === 0) {
        clonedRoute.hidden = true
      }
    }

    // 检查路由权限
    if (clonedRoute.meta && clonedRoute.meta.roles) {
      const hasPermission = clonedRoute.meta.roles.includes(userRole)

      // 如果没有权限且不是基础路由，则隐藏
      if (!hasPermission && !clonedRoute.hidden) {
        clonedRoute.hidden = true
      }
    }

    return clonedRoute
  })
}

// 创建路由
const router = createRouter()

// 重设路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
